<template>
    <div id="Statistics">

        <Head />
        <div class="hotspot clear">
            <Nav ms="/Innovation" />
            <div v-if="tabChange == 0" class="H-right">
                <!-- <span style="margin-left:1rem;font-size:0.18rem;font-weight:800;background:url('../../assets/back/txt.png') left center no-repeat;">通知公告</span> -->
                <div class="title">创新课堂管理</div>
                <div class="H-header">
                    <div class="t-right">
                        <div class="btn btnmini" @click="tabClick('add')">新增</div>
                    </div>
                    <div class="t-left">
                        <span>课程类型</span>
                        <select name id v-model="videoType" @change="getNew">
                            <option value>全部</option>
                            <option value="1" label="创新课堂"> </option>
                            <option value="2" label="创新讲坛"> </option>
                        </select>
                        <span>上架状态</span>
                        <select name id v-model="Status" @change="getNew">
                            <option value>全部</option>
                            <option value="0" label="上架"> </option>
                            <option value="1" label="下架"> </option>
                        </select>
                        <span>是否推荐</span>
                        <select name id v-model="Recommend" @change="getNew">
                            <option value>全部</option>
                            <option value="1" label="推荐"> </option>
                            <option value="0" label="不推荐"> </option>
                        </select>
                    </div>
                </div>
                <div class="t_main">
                    <el-table border
                        :header-cell-style="{ 'background-color': '#001743', 'color': '#fff', 'height': '0.5rem' }"
                        :stripe="true" :data="tableData1" style="width: 100%;max-height:95%"
                        :row-style="{ 'height': '0.4rem' }">
                        <el-table-column label="序号" header-align="center" align="center" width="60">
                            <template slot-scope="scope">
                                <p>{{ scope.row.index }}</p>
                                <i v-if="scope.row.TopNo > 0" class="zd"></i>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Type" label="类别" header-align="center" align="center" width="100">
                            <template slot-scope="scope">
                                {{ scope.row.Type == '1' ? '创新课堂' : '创新讲坛' }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="Classname" label="课程名称" header-align="center" align="center" width="150">
                        </el-table-column>
                        <el-table-column prop="Details" label="封面图片" header-align="center" align="center">
                            <template slot-scope="scope">
                                <div class="imgurl">

                                    <img :src="scope.row.Image" />
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Details" label="视频地址" show-overflow-tooltip header-align="center" width="100"
                            align="center">
                            <template slot-scope="scope">
                                <el-link :href="scope.row.Link" target="_blank">{{ scope.row.Link }}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Issue" label="期数" header-align="center" align="center" width="80">
                        </el-table-column>
                        <el-table-column prop="Recommend" label="推荐状态" header-align="center" align="center" width="100">
                            <template slot-scope="scope">
                                <el-tooltip :content="scope.row.Recommend == '1' ? '推荐' : '不推荐'" placement="top">
                                    <el-switch v-model="scope.row.Recommend" active-value="1" active-color="#13ce66"
                                        @change="RecommendChange(scope.row)">
                                    </el-switch>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Status" label="上架状态" header-align="center" align="center" width="100">
                            <template slot-scope="scope">
                                <el-tooltip :content="scope.row.Status == '0' ? '上架' : '下架'" placement="top">
                                    <el-switch v-model="scope.row.Status" active-value="0" active-color="#13ce66"
                                        @change="statusChange(scope.row)">
                                    </el-switch>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column prop="UpdateTime" label="更新时间" header-align="center" align="center" width="150">
                        </el-table-column>
                        <el-table-column label="操作" header-align="center" align="center" fixed="right" :width="wid">
                            <template slot-scope="scope">
                                <el-button size="mini" style="background: #2D65D2;color:#ffffff;"
                                    @click="tabClick('edit', scope.row)">修改</el-button>
                                <el-button size="mini" type="danger" @click="Del(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination style="text-align: right;height: 0.45rem;" v-if="tableData1.length > 0"
                        @current-change="CurrentChange1" @size-change="handleSizeChange1" :current-page="Page1"
                        :page-size="PageSize1" :page-sizes="[10, 20, 30]" layout="total,sizes, prev, pager, next, jumper"
                        :total="total1"></el-pagination>
                </div>

            </div>
            <div v-if="tabChange == 1" class="H-right">
                <div class="btn btnmini" style="margin-bottom: 0.2rem;" @click="tabChange = 0">返回</div>
                <div class="f-info">
                    <div class="p-info">
                        <div class="p-input">
                            <span>课程名称：</span>
                            <input type="text" v-model="infoForm.Classname" />
                            <i>*</i>
                        </div>
                        <div class="p-input">
                            <span>视频类型：</span>
                            <select v-model="infoForm.types">
                                <option value="1" label="创新课堂"> </option>
                                <option value="2" label="创新讲坛"> </option>
                            </select>
                            <i>*</i>
                        </div>
                        <div class="p-input">
                            <span>播放次数：</span>
                            <input type="number" v-model="infoForm.Number" />
                        </div>
                        <div class="p-input" v-if="infoForm.types == '2'">
                            <span>视频期数：</span>
                            <input type="number" v-model="infoForm.Issue" />
                        </div>
                        <div class="p-input" v-if="infoForm.types == '2'">
                            <span>演讲人：</span>
                            <input type="text" v-model="infoForm.Publisher" />
                        </div>
                        <div class="p-input" v-if="infoForm.types == '1'">
                            <span>是否推荐：</span>
                            <el-radio v-model="infoForm.Recommend" label="1">推荐</el-radio>
                            <el-radio v-model="infoForm.Recommend" label="0">不推荐</el-radio>
                        </div>
                        <div class="p-input">
                            <span>上下架状态：</span>
                            <select v-model="infoForm.Status">
                                <option :value="0" label="上架"> </option>
                                <option :value="1" label="下架"> </option>
                            </select>
                            <i>*</i>
                        </div>
                        <div class="p-input">
                            <span>封面图片：</span>
                            <div>
                                <div @click="uploadImg" class="btn btnmini" style="width:1rem;">上传图片</div>
                                <img v-if="infoForm.Image" :src="infoForm.Image" class="avatar"
                                    style="width:2rem; margin-top: 10px;" />
                            </div>
                            <i></i>
                        </div>
                        <div class="p-input">
                            <span>视频链接：</span>
                            <input type="text" v-model="infoForm.Link" placeholder="上传视频后自动填入" />
                            <i>*</i>
                        </div>
                        <div class="p-input">
                            <span>上传视频：</span>
                            <div>
                                <div @click="uploadVid" class="btn btnmini" style="width:1rem;">上传视频</div>
                                <el-progress :text-inside="true" v-if="videoProgress" :stroke-width="26"
                                    :percentage="videoProgress" style="margin: 0.1rem 0;"></el-progress>
                                <!-- <img v-if="infoForm.Link" :src="infoForm.Link" class="avatar"
                                    style="width:2rem; margin-top: 10px;" /> -->
                                <video controls loop muted v-if="infoForm.Link">
                                    <source :src="infoForm.Link" type="video/mp4">
                                    您的浏览器不支持 HTML5 视频。
                                </video>
                            </div>
                            <i></i>
                        </div>
                        <!-- <div class="p-input">
                <span>代码：</span>
                <input type="text" v-model="infoForm.FileCode" />
                <i></i>
              </div>-->
                        <!-- <div>
                            <span>内容：</span>
                            <div class="quill">
                                <wangEditor v-model="infoForm.Details" @change="change" />
                            </div>
                            <i>*</i>
                        </div> -->
                    </div>
                    <div class="f-bottom">
                        <div class="btn" @click="submit">提交</div>
                    </div>
                </div>
            </div>
        </div>
        <el-upload ref="uploads" id="upload1" style="opacity:0;height:0;overflow:hidden;" class="avatar-uploader1"
            :http-request="upload" :auto-upload="false" :on-change="submitUpload" action="upload1" :show-file-list="false">
            <i class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <el-upload ref="uploadVideo" id="upload2" style="opacity:0;height:0;overflow:hidden;" class="avatar-uploader2"
            :http-request="uploadVideo" :auto-upload="false" :on-change="submitUploadVideo" action="upload1"
            :show-file-list="false">
            <i class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <Foot />
    </div>
</template>

<script>
import Head from "../../components/BackHead";
import Foot from "../../components/Foot";
import Nav from "../../components/BackNav";
export default {
    name: "Announcement",
    data() {
        return {
            index: "",
            token: "",
            tabChange: 0,
            videoType: "",
            Status: "",
            Recommend: "",
            page: 1,
            num: 10,
            total1: 0,
            tableData1: [],
            Page1: 1,
            value1: 1,
            PageSize1: 10,
            isPopup: false,
            classForm: "",
            fileList: [],
            options: [],
            infoForm: {},
            type: '',
            banner_id: '',
            videoProgress: 0
        }
    },
    created() {
        // sessionStorage.setItem("token",'company-70374788cd5a72fc3fb58c59f1c3fdc3')
        this.token = sessionStorage.getItem("token");
        this.getOptions();
        this.getinfo();
    },
    mounted() {
        if (window.outerWidth < 1540) this.wid = "150";
        else this.wid = "210";
    },
    methods: {
        getNew() {
            this.getinfo()
        },
        getType(e) {
            for (var i = 0; i < this.options.length; i++) {
                if (this.options[i].banner_id == e) {
                    return this.options[i].msg;
                }
            }
        },
        getOptions() {
            var that = this;
            that.$axios
                .post(
                    "banner/index?token=" +
                    sessionStorage.getItem("token") +
                    "&tablename=information&fieldname=type"
                )
                .then((res) => {
                    if (res.data.code == 10000) {
                        console.log(res.data.data.list, 'options');
                        this.options = res.data.data.list;
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: "warning",
                        });
                    }
                });
        },
        getinfo(a) {
            if (a == 1) {
                this.page = 1;
            }
            var that = this;
            that.$axios
                .post(
                    "classes/backlist?token=" + sessionStorage.getItem("token"),
                    that.$qs.stringify({
                        Type: this.videoType,
                        Status: this.Status,
                        Recommend: this.Recommend,
                        page: this.page,
                        num: this.num
                    })
                )
                .then((res) => {
                    if (res.data.code == 10000) {
                        that.fileList = [];
                        console.log(res.data.data);
                        this.tableData1 = res.data.data.list;
                        this.tableData1.forEach((val, index) => {
                            val.index = index + 1;
                        });
                        console.log(this.tableData1);
                        this.total1 = res.data.data.total_num;
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: "warning",
                        });
                    }
                });
        },
        CurrentChange1(val) {
            this.page = val;
            this.getinfo();
        },
        handleSizeChange1(val) {
            this.num = val;
            this.getinfo();
        },
        Del(e) {
            var that = this;
            this.$confirm("确认删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    that.$axios
                        .post(
                            "classes/delclass?token=" + sessionStorage.getItem("token"),
                            that.$qs.stringify({ ID: e.ID })
                        )
                        .then((res) => {
                            console.log(res);
                            if (res.data.code == 10000) {
                                that.$message({
                                    message: "删除成功",
                                    type: "success",
                                });
                                that.getinfo();
                                // this.reload();
                            } else {
                                that.$message.error(res.data.msg);
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        statusChange(e) {
            let that = this
            this.$axios
                .post(
                    "classes/status?token=" + sessionStorage.getItem("token"),
                    that.$qs.stringify({ ID: e.ID })
                )
                .then((res) => {
                    console.log(res);
                    if (res.data.code == 10000) {
                        that.$message({
                            message: "状态切换成功",
                            type: "success",
                        });
                        that.getinfo();
                        // this.reload();
                    } else {
                        that.$message.error(res.data.msg);
                    }
                });
        },
        RecommendChange(e) {
            let that = this
            this.$axios
                .post(
                    "classes/recommend?token=" + sessionStorage.getItem("token"),
                    that.$qs.stringify({ ID: e.ID })
                )
                .then((res) => {
                    console.log(res);
                    if (res.data.code == 10000) {
                        that.$message({
                            message: "状态切换成功",
                            type: "success",
                        });
                        that.getinfo();
                        // this.reload();
                    } else {
                        that.$message.error(res.data.msg);
                    }
                });
        },
        tabClick(type, form) {
            this.tabChange = 1
            this.type = type
            console.log(form)
            if (type == 'add') {
                this.infoForm = {}
            } else {
                this.infoForm = JSON.parse(JSON.stringify(form))
                this.infoForm.types = this.infoForm.Type
            }
        },
        uploadImg() {
            document.querySelector(".avatar-uploader1 input").click();
        },
        uploadVid() {
            document.querySelector(".avatar-uploader2 input").click();
        },
        upload(file) {
            let that = this;
            console.log(file);
            var formData = new FormData();
            formData.append("file", file.file);
            formData.append("upload_type", "image");
            that.$axios
                .post(
                    "upload/index?token=" + sessionStorage.getItem("token"),
                    formData,
                    {
                        headers: {
                            "Content-type": "multipart/form-data",
                        },
                    }
                )
                .then((res) => {
                    if (res.data.code == 10000) {
                        console.log(res.data.data);
                        this.infoForm.Image = res.data.data;
                        this.$message({
                            message: res.data.msg,
                            type: "success",
                        });
                        this.$forceUpdate()
                    }
                });
            this.$refs.uploads.clearFiles();
        },
        uploadVideo(file) {
            let that = this;
            console.log(file);
            this.videoProgress = 0
            for (let i = 1; i <= 4; i++) {
                var formData = new FormData();
                formData.append("file", file.file);
                formData.append("blob_num", i);
                formData.append("total_blob_num", 4);
                formData.append("file_name", file.file.name);
                that.$axios
                    .post(
                        "upload/fenduan?token=" + sessionStorage.getItem("token"),
                        formData,
                        {
                            headers: {
                                "Content-type": "multipart/form-data",
                            },
                        }
                    )
                    .then((res) => {
                        if (res.data.code == 10000) {
                            console.log(res.data.data);
                            if (res.data.data) {
                                this.$message({
                                    message: '上传成功',
                                    type: "success",
                                });
                                this.infoForm.Link = res.data.data;
                            }
                            this.videoProgress = this.videoProgress + 25
                            this.$forceUpdate()
                        }
                    });
            }
            this.$refs.uploads.clearFiles();
        },
        submitUpload() {
            this.$refs.uploads.submit();
        },
        submitUploadVideo() {
            this.$refs.uploadVideo.submit();
        },
        submit() {
            let that = this
            if (this.type == 'add') {
                this.$confirm("确认提交该信息, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    that.$axios
                        .post(
                            "classes/add?token=" + sessionStorage.getItem("token"),
                            that.$qs.stringify(this.infoForm)
                        )
                        .then((res) => {
                            if (res.data.code == 10000) {
                                console.log(res.data.data);
                                that.fileList = [];
                                for (var key in that.infoForm) {
                                    that.infoForm[key] = "";
                                }
                                //提交成功后返回
                                this.tabChange = 0;
                                that.$message({
                                    message: res.data.msg,
                                    type: "success",
                                });
                                that.getinfo();
                                // this.Popups(0);
                            } else {
                                this.$message({
                                    message: res.data.msg,
                                    type: "warning",
                                });
                            }
                        });
                });
            } else {
                this.$confirm("确认提交该信息, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    that.$axios
                        .post(
                            "classes/update?token=" + sessionStorage.getItem("token"),
                            that.$qs.stringify(this.infoForm)
                        )
                        .then((res) => {
                            if (res.data.code == 10000) {
                                console.log(res.data.data);
                                that.fileList = [];
                                for (var key in that.infoForm) {
                                    that.infoForm[key] = "";
                                }
                                //提交成功后返回
                                this.tabChange = 0;
                                that.$message({
                                    message: res.data.msg,
                                    type: "success",
                                });
                                that.getinfo();
                                // this.Popups(0);
                            } else {
                                this.$message({
                                    message: res.data.msg,
                                    type: "warning",
                                });
                            }
                        });
                });
            }
        }
    },
    components: {
        Head,
        Foot,
        Nav,
    },
}
</script>
<style lang="less" scoped>
.el-dropdown {
    display: none;
}

.btns {
    display: flex;
}

@media screen and (max-width: 1800px) {
    .el-dropdown {
        display: block;
    }

    .btns {
        display: none !important;
    }

    .el-table__row td:last-child {
        .cell {
            padding-left: 0px;

            .el-button {
                font-size: 12px;
            }
        }
    }

    .el-dropdown-menu {
        li {
            padding: 0;

            span {
                display: inline-block;
                padding: 0 20px;
                width: 100%;
                height: 100%;
            }
        }

        li:hover {
            color: #fff !important;
        }

        li:first-of-type:hover {
            background: #2d65d2;
        }

        li:nth-of-type(2):hover {
            background: #f3252f;
        }

        li:last-of-type:hover {
            background: #f76423;
        }
    }
}

.fj {
    width: 50%;

    .anniu {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-left: 0.2rem;
    }
}

.clear:after {
    /*伪元素是行内元素 正常浏览器清除浮动方法*/
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
}

select {
    font-size: 0.16rem;
    height: 0.5rem;
}

// .editor{
//   width: 100%;
//   height: 3rem;
// }
.btn {
    width: 4.6rem;
    cursor: pointer;
    height: 0.58rem;
    line-height: 0.58rem;
    font-size: 0.17rem;
    text-align: center;
    background: #2d65d2;
    color: #fff;
}

.btnchange {
    background-color: #ffffff;
    border: 1px #aaaaaa solid;
    color: #000000;
}

.btnmini {
    width: 1rem;
    height: 0.4rem;
    line-height: 0.4rem;
    border-radius: 0.05rem;
}

.hotspot {
    width: 100%;
    min-width: 1000px;
    font-size: 0.16rem;
    padding: 0.28rem 2.54rem;
    box-sizing: border-box;

    .H-right {
        position: relative;
        width: 11.5rem;
        padding-left: 0.2rem;
        height: 100%;
        float: right;
        min-height: 8rem;
        border-left: 1px #eeeeee solid;

        .title {
            font-size: 0.4rem;
            margin: 0.2rem 0 0.5rem;
            text-align: center;
        }

        .btnselect {
            display: flex;
        }

        .H-header {
            .t-left {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                height: 0.5rem;

                select,
                div,
                input {
                    width: 2rem;
                    height: 0.4rem;
                    border-radius: 0;
                }

                span {
                    margin: 0 0.1rem;
                }

                input {
                    padding: 0.05rem;
                }
            }

            .t-right {
                float: right;
            }
        }
    }
}

.Popup {
    width: 100%;
    position: absolute;
    top: 0;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 1000;

    .none {
        width: 100%;
        height: 100%;
        position: relative;
    }

    .a_forms {
        position: absolute;
        left: 50%;
        top: 0.5rem;
        transform: translate(-50%, 0);
        width: 10.11rem;
        height: 8rem;
        background: white;
        font-size: 0.16rem;

        .f-top {
            height: 0.5rem;
            width: 100%;
            text-align: center;
            line-height: 0.5rem;
            position: relative;
            border-bottom: 1px #cfcfcf solid;

            div {
                cursor: pointer;
                position: absolute;
                right: 0;
                top: 0;
                height: 0.5rem;
                width: 0.5rem;
                background: url("../../assets/back/x.png") center center no-repeat;
            }
        }
    }
}

.t_main {
    .zd {
        display: inline-block;
        width: 0.3rem;
        height: 0.3rem;
        background-image: url("../../assets/back/zd.png");
        background-repeat: no-repeat;
        position: absolute;
        top: 0;
        left: 0;
        background-size: 100%;
    }
}

.f-info {
    padding: 0 0.54rem;

    .p-info {
        >.p-input {
            align-items: center;

            >div {
                position: relative;
                flex: 1;
                margin: 0 0.2rem;

                >video {
                    max-height: 5rem;
                }
            }

        }

        >.upimg {
            align-items: center;
            justify-content: space-between;
        }

        >div {
            margin: 0.2rem 0;
            display: flex;

            >.p-time {
                position: relative;
                flex: 1;
                margin: 0 0.2rem;

                >input {
                    width: 100%;
                    padding: 0.05rem;
                    height: 0.4rem;
                    border: 1px #cccccc solid;
                }

                .p-select {
                    width: 100%;
                    top: 0;
                    left: 0;
                    opacity: 0;
                    position: absolute;
                }

                .icon {
                    position: absolute;
                    top: 0;
                    right: 0;
                    height: 0.4rem;
                    width: 0.4rem;
                    background: url("../../assets/back/time.png") center center no-repeat;
                }
            }

            input,
            select {
                flex: 1;
                padding: 0.05rem;
                margin: 0 0.2rem;
                height: 0.4rem;
                border: 1px #cccccc solid;
            }

            >.quill {
                max-width: 89%;
                flex: 1;
                margin: 0 0.2rem;
            }

            i {
                font-style: normal;
                color: #ff0d0d;
                width: 0.2rem;
            }
        }
    }

    .f-bottom {
        display: flex;
        justify-content: space-around;
        align-items: center;
    }
}

.hMain {
    position: relative;
    border: 1px solid #ababab;
    margin: 0 auto;
    background: #fafdff;

    span {
        display: inline-block;
        width: 0.1rem;
    }

    >p {
        width: 97%;
        font-size: 0.22rem;
        margin: 0 auto;
        padding-bottom: 0.1rem;
        color: #4f4f4f;
        text-indent: 2em;
        margin-bottom: 0.1rem;
    }

    >p:nth-of-type(1) {
        text-align: center;
        font-size: 0.35rem;
        color: #333;
        border-bottom: 1px solid #ccc;
        padding-bottom: 0.3rem;
        font-weight: bold;
        margin: 0.3rem 0;
    }

    >p:nth-of-type(2) {
        height: 0.5rem;
        line-height: 0.5rem;
        background: #f4f9fd;
        text-align: center;
        font-size: 0.18rem;
        color: #666666;
        margin-top: 0.3rem;
        margin-bottom: 0.4rem;
    }

    div {
        width: 96%;
        border: 1px dashed #ddd;
        // background: #f0f6fb;
        margin: 0.6rem 0 0 0.2rem;
        padding: 0.1rem 0;
        font-size: 0.2rem;
        text-indent: 2em;

        p {
            line-height: 1.5;
        }

        p:nth-of-type(1) {
            margin-bottom: 0.1rem;
        }
    }

    .fj {
        p {
            margin: 0.3rem 0 0.2rem !important;
        }

        ul {
            padding-left: 0.6rem;
        }

        li {
            font-size: 0.16rem;
            text-decoration: underline;
            margin-bottom: 0.2rem;

            a.active {
                color: royalblue;
            }
        }
    }
}

.imgurl {

    width: 100%;
    height: 100px;

    img {
        width: 100%;
        height: 100%;
        object-fit: contain
    }
}
</style>